// src/services/webhookLogs.js
export async function getWebhookLogs() {
  const token = localStorage.getItem("sobevenda_token");
  const resp = await fetch("https://api.sobevenda.com.br/api-proxy/affiliate/webhook_logs", {
    headers: { Authorization: `Bearer ${token}` }
  });
  if (!resp.ok) throw new Error("Erro ao buscar logs");
  return await resp.json();
}
